interface IConfig {
  root: string; //root url of application
  diyNewApiUrl: string; //root url of DIY REVAMP
  piChainNewApiUrl: string; //root url of PiChain REVAMP
  tempToken: string; //DIY REVAMP API TOKEN (This will be corrected by backend TEAM)
  diyApiUrl: string; //api bas url for diy apis
  apiUrl: string; //api base url of application
  javaComUrl: string; //java api url
  whatsappBearerToken: string; //Whatsapp Bearer Token for consent and communication
  clientId: string; //clientId for DigiLocker config
  redirectUri: string; //redirection url from DigiLocker to application
  cleverTapId: string; //CleverTap config id
  clientQuesttionSourceId: string; //
  ClientProfilingDataSourseId: string;
  apiKey: string;
  digiLockerSource: number;
  aopNewApiUrl?: string;
  pricingPage: string;
  publicKey: string;
  secretKey: string;
  hideInvestment:boolean;
  sdkUrl: string;
  sdkSelfieScript?: any;
  sdkSignatureUrl?: string | any;
  sdkSignatureScript?: any;
}
const dev: IConfig = {
  //root: "https://onboardinguat.nuvamawealth.com/dev/",
  root: "http://localhost:3001/",
  //diyNewApiUrl: "https://nwuat.nuvamawealth.com/DIYAPI/api/",
  // aopNewApiUrl: "https://nwaop.nuvamawealth.com/mwapi/api/",
  // diyNewApiUrl: "https://nwaop.nuvamawealth.com/mwapi/api/",
  aopNewApiUrl: "https://nwuat.nuvamawealth.com/AOPAPI/api/",
  diyNewApiUrl: "https://nwuat.nuvamawealth.com/AOPAPI/api/",
  piChainNewApiUrl: "https://nwuat.nuvamawealth.com/DIYAPI/",
  tempToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEiLCJhcGlrZXkiOiJjNDExMjFlZC1iNmZiLWM5YTYtYmM5Yi01NzRjODI5MjllN2UiLCJuYmYiOjE2NTg0NzQ2MTgsImV4cCI6MTY1ODU2MTAxOCwiaWF0IjoxNjU4NDc0NjE4fQ.fJdG6pwqwuY196E2Y9xxm7N7ncyl23RIY0-3lAanvwI",
  diyApiUrl: "",
  apiUrl: "https://nwuat.nuvamawealth.com/DIYAPI/api/",
  javaComUrl: "",
  whatsappBearerToken: "Bearer eyJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1NzEyMjQ4ODEsImV4cCI6MTU4MDMyMjYwMH0.Q-IE3XqL5s8DS7QuN0TWscyzrThMi29Tbfb65wDvamg",
  clientQuesttionSourceId: "42",
  ClientProfilingDataSourseId: "42",
  //DigiLocker config
  clientId: "E517209A",
  redirectUri: "https://onboardinguat.nuvamawealth.com/dev/showdocuments",

  // CleverTap config
  cleverTapId: "TEST-6Z6-556-W55Z",
  apiKey: "c41121ed-b6fb-c9a6-bc9b-574c82929e7e",
  digiLockerSource: 2,
  pricingPage: "https://vamauat.nuvamawealth.com/alpha/our-pricing",
  publicKey: "edelweis",
  secretKey: "edelweiss1234567",
  hideInvestment:true,
  sdkUrl: "https://8z3gyr1r91.execute-api.ap-south-1.amazonaws.com/default/test_token_face_liveliness?RefId=4567890&client_key=tljkwvr1fh",
  sdkSelfieScript: "https://d1qpv0waqdbwtx.cloudfront.net/FaceNuvSpec.js",
  sdkSignatureUrl: "https://jc2l8chno8.execute-api.ap-south-1.amazonaws.com/default/TokenCheck",
  sdkSignatureScript: "https://d36597mw1g52r7.cloudfront.net/NuvamaSignUat.js"
};

const uat: IConfig = {
//  root:"https://onboardinguat.nuvamawealth.com/",
  root: "https://onboardinguat.nuvamawealth.com/",
  // diyNewApiUrl: "https://nwuat.nuvamawealth.com/DIYAPI/api/",
  aopNewApiUrl: "https://nwuat.nuvamawealth.com/AOPAPI/api/",
  diyNewApiUrl: "https://nwuat.nuvamawealth.com/AOPAPI/api/",
  piChainNewApiUrl: "https://nwuat.nuvamawealth.com/DIYAPI/",
  tempToken: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjEiLCJhcGlrZXkiOiJjNDExMjFlZC1iNmZiLWM5YTYtYmM5Yi01NzRjODI5MjllN2UiLCJuYmYiOjE2NTg0NzQ2MTgsImV4cCI6MTY1ODU2MTAxOCwiaWF0IjoxNjU4NDc0NjE4fQ.fJdG6pwqwuY196E2Y9xxm7N7ncyl23RIY0-3lAanvwI",
  diyApiUrl: "",
  apiUrl: "https://nwuat.nuvamawealth.com/DIYAPI/api/",
  javaComUrl: "",
  whatsappBearerToken: "Bearer eyJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1NzEyMjQ4ODEsImV4cCI6MTU4MDMyMjYwMH0.Q-IE3XqL5s8DS7QuN0TWscyzrThMi29Tbfb65wDvamg",
  clientQuesttionSourceId: "42",
  ClientProfilingDataSourseId: "42",
  //DigiLocker config
  clientId: "E517209A",
  redirectUri: "https://onboardinguat.nuvamawealth.com/showdocuments",
  //redirectUri: "https://onboardinguat.nuvamawealth.com/showdocuments",

  // CleverTap config
  cleverTapId: "TEST-6Z6-556-W55Z",
  apiKey: "c41121ed-b6fb-c9a6-bc9b-574c82929e7e",
  digiLockerSource: 2,
  pricingPage: "https://vamauat.nuvamawealth.com/alpha/our-pricing",
  publicKey: "edelweis",
  secretKey: "edelweiss1234567",
  hideInvestment:true,
  sdkUrl: "https://8z3gyr1r91.execute-api.ap-south-1.amazonaws.com/default/test_token_face_liveliness?RefId=4567890&client_key=tljkwvr1fh",
  sdkSelfieScript: "https://d1qpv0waqdbwtx.cloudfront.net/FaceNuvSpec.js",
  sdkSignatureUrl: "https://jc2l8chno8.execute-api.ap-south-1.amazonaws.com/default/TokenCheck",
  sdkSignatureScript: "https://d36597mw1g52r7.cloudfront.net/NuvamaSignUat.js"
};

const preProd: IConfig = {
  root: "https://onboardingcug.nuvamawealth.com/",
  //diyNewApiUrl: "https://nwaop.nuvamawealth.com/mwapi/api/",
  // aopNewApiUrl: "https://nwuat.nuvamawealth.com/AOPAPICUG/api/",
  // diyNewApiUrl: "https://nwuat.nuvamawealth.com/AOPAPICUG/api/",
  aopNewApiUrl: "https://nwaop.nuvamawealth.com/mwapi/api/",
  diyNewApiUrl: "https://nwaop.nuvamawealth.com/mwapi/api/",
  piChainNewApiUrl: "https://capsapi.nuvamawealth.com/DIYAPI/",
  tempToken: "",
  diyApiUrl: "",
  apiUrl: "https://capsapi.nuvamawealth.com/DIYAPIPre/api/",
  javaComUrl: "",
  whatsappBearerToken: "Bearer eyJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1NzEyMjQ4ODEsImV4cCI6MTU4MDMyMjYwMH0.Q-IE3XqL5s8DS7QuN0TWscyzrThMi29Tbfb65wDvamg",
  clientQuesttionSourceId: "15",
  ClientProfilingDataSourseId: "15",
  //DigiLocker config
  clientId: "FD8066A1",
  redirectUri: "https://onboardingcug.nuvamawealth.com/showdocuments",

  // CleverTap config
  cleverTapId: "TEST-6Z6-556-W55Z",
  apiKey: "c41121ed-b6fb-c9a6-bc9b-574c82929e7e",
  digiLockerSource: 2,
  pricingPage: "https://vamacug.nuvamawealth.com/our-pricing",
  publicKey: "edelweis",
  secretKey: "edelweiss1234567",
  hideInvestment:true,
  sdkUrl: "https://8z3gyr1r91.execute-api.ap-south-1.amazonaws.com/default/test_token_face_liveliness?RefId=4567890&client_key=tljkwvr1fh",
  sdkSelfieScript: "https://d1qpv0waqdbwtx.cloudfront.net/FaceNuvSpec.js",
  sdkSignatureUrl: "https://jc2l8chno8.execute-api.ap-south-1.amazonaws.com/default/TokenCheck",
  sdkSignatureScript: "https://d36597mw1g52r7.cloudfront.net/NuvamaSignUat.js"
};

const prod: IConfig = {
  root: "https://onboarding.nuvamawealth.com/",
 // diyNewApiUrl: "https://nwaop.nuvamawealth.com/mwapi/api/",
  aopNewApiUrl: "https://nwaop.nuvamawealth.com/mwapi/api/",
  diyNewApiUrl: "https://nwaop.nuvamawealth.com/mwapi/api/",
  piChainNewApiUrl: "https://capsapi.nuvamawealth.com/DIYAPI/",
  tempToken: "",
  diyApiUrl: "",
  apiUrl: "https://capsapi.nuvamawealth.com/DIYAPI/api/",
  javaComUrl: "",
  whatsappBearerToken: "Bearer eyJhbGciOiJIUzI1NiJ9.eyJpYXQiOjE1NzEyMjQ4ODEsImV4cCI6MTU4MDMyMjYwMH0.Q-IE3XqL5s8DS7QuN0TWscyzrThMi29Tbfb65wDvamg",
  clientQuesttionSourceId: "15",
  ClientProfilingDataSourseId: "15",

  //DigiLocker config
  clientId: "FD8066A1",
  redirectUri: "https://onboarding.nuvamawealth.com/showdocuments",

  // CleverTap config
  cleverTapId: "6K9-KW7-745Z",
  apiKey: "c41121ed-b6fb-c9a6-bc9b-574c82929e7e",
  digiLockerSource: 2,
  pricingPage: "https://www.nuvamawealth.com/our-pricing",
  publicKey: "edelweis",
  secretKey: "edelweiss1234567",
  hideInvestment:true,
  sdkUrl: "https://8z3gyr1r91.execute-api.ap-south-1.amazonaws.com/default/test_token_face_liveliness?RefId=4567890&client_key=tljkwvr1fh",
  sdkSelfieScript: "https://d1qpv0waqdbwtx.cloudfront.net/FaceNuvSpec.js",
  sdkSignatureUrl: "https://jc2l8chno8.execute-api.ap-south-1.amazonaws.com/default/TokenCheck",
  sdkSignatureScript: "https://d36597mw1g52r7.cloudfront.net/NuvamaSignUat.js"
};

const config =
  process.env.REACT_APP_ENV === "production"
    ? prod
    : process.env.REACT_APP_ENV === "preprod"
      ? preProd
      : process.env.REACT_APP_ENV === "uat"
        ? uat
        : dev;

export default config;
